<template>
  <modal-ui :visible="visible" @close="closeModal" title="Додати послугу">
    <div
      class="drop-zone"
      @dragover.prevent
      @dragenter.prevent
      @dragenter="isDragging = true"
      @dragleave="isDragging = false"
      @drop.prevent="handleDrop"
      :style="
        isDragging
          ? 'border-color:#007BFF;'
          : imagesError.length > 0
          ? 'border-color: red;'
          : ''
      "
    >
      <v-col
        cols="8"
        v-if="service.image && service.image.path"
        class="text-center"
      >
        <img
          :src="service.image.path"
          width="264px"
          height="181px"
          style="object-fit: cover"
        />
        <p
          style="
            color: #a6a6ac;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            margin: 10px 0px;
          "
        >
          {{ service.image.service_name_de }}
        </p>
        <admin-submit-button height="38px" @click="triggerFileInput"
          >Змінити зображення</admin-submit-button
        >
        <v-col cols="12" class="text-center" v-if="imageError">
          <p style="color: red">{{ imageError }}</p>
        </v-col>
      </v-col>

      <v-col cols="12" class="text-center" v-else>
        <v-icon color="#838B94" size="40px">mdi-cloud-upload</v-icon>
        <p style="margin: 22px 0px">
          Перетягніть зображення розміром 1440×984 сюди або
        </p>
        <admin-submit-button height="38px" @click="triggerFileInput"
          >Виберіть зображення</admin-submit-button
        >
        <v-col cols="12" class="text-center" v-if="imageError">
          <p style="color: red">{{ imageError }}</p>
        </v-col>
      </v-col>
    </div>
    <input
      type="file"
      ref="fileInput"
      accept="image/png, image/jpeg"
      style="display: none"
      @change="handleFileSelect"
    />
    <p class="field-name" style="margin-top: 20px">Назва послуги</p>
    <v-text-field
      v-model="service.service_name_de"
      outlined
      dense
      placeholder="Введіть назву послуги"
      :error-messages="nameError"
    />
    <v-row no-gutters align="center">
      <h3
        style="
          color: #18181b;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        "
      >
        Пункти
      </h3>
      <v-row no-gutters align="center" justify="end">
        <admin-submit-button
          style="border-radius: 6px !important"
          height="38px"
          @click="addPoint"
          :disabled="$v.service.text_points.$each.$invalid"
        >
          <v-icon color="#FFFFFF" style="margin-right: 4px" size="22px"
            >mdi-plus</v-icon
          >
          Додати пункт</admin-submit-button
        >
      </v-row>
    </v-row>
    <div :key="listKey">
      <div
        v-for="(point, index) in service.text_points.filter((p) => !p.delete)"
        :key="index"
        style="margin-top: 22px"
      >
        <v-row no-gutters style="margin-bottom: 7px">
          <p class="field-name" style="margin-bottom: 0px">
            Пункт {{ index + 1 }}
          </p>
          <v-row no-gutters justify="end" v-if="service.text_points.length > 1">
            <v-icon
              color="#000000"
              size="24px"
              style="cursor: pointer"
              @click="deleteTextPoint(point.id, index)"
              >mdi-minus</v-icon
            >
          </v-row>
        </v-row>
        <v-textarea
          v-model="point.text"
          outlined
          dense
          placeholder="Опишіть послугу"
          height="65px"
          hide-details
          @change="point.is_edited = true"
          :error-messages="textPointsDescriptionErrors(index)"
        />
      </div>
    </div>

    <v-row no-gutters style="margin-top: 22px">
      <admin-cancel-btn
        height="38px"
        @click="$emit('close')"
        width="calc(50% - 6px)"
        style="margin-right: 12px"
        >Скасувати</admin-cancel-btn
      >
      <admin-submit-button
        v-if="isEdit"
        :loading="isLoadingBtn"
        height="38px"
        width="calc(50% - 6px)"
        @click="updateService"
        >Зберегти</admin-submit-button
      >
      <admin-submit-button
        v-else
        :loading="isLoadingBtn"
        height="38px"
        width="calc(50% - 6px)"
        @click="createService"
        >Додати послугу</admin-submit-button
      >
    </v-row>
  </modal-ui>
</template>

<script>
import modalUi from "@/components/UI/Modals/modalUI.vue";
import AdminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import { validationMixin } from "vuelidate";
import AdminCancelBtn from "../../UI/Btns/adminCancelBtn.vue";
import { required } from "vuelidate/lib/validators";
import servicesService from "../../../requests/Admin/servicesService";
export default {
  mixins: [validationMixin],
  components: {
    modalUi,
    AdminSubmitButton,
    AdminCancelBtn,
  },
  data: () => ({
    allowedTypes: ["image/png", "image/jpeg"],
    maxSize: 1024 * 1024, // 1MB
    imageError: "",
    isDragging: false,
    isLoadingBtn: false,
    service: {
      image: null,
      text_points: [
        {
          id: 1,
          text: "",
        },
      ],
    },
    listKey: 0,
  }),
  props: {
    visible: {
      default: false,
    },
    isEdit: {
      require: false,
    },
    itemForEdit: {
      require: false,
    },
  },
  validations: {
    service: {
      image: {
        required,
      },
      service_name_de: {
        required,
      },
      text_points: {
        $each: {
          text: { required },
        },
      },
    },
  },
  mounted() {
    if (this.isEdit) {
      this.service = this.itemForEdit;
    }
  },
  methods: {
    async createService() {
      this.$v.service.$touch();
      if (!this.$v.service.$invalid) {
        this.isLoadingBtn = true;
        try {
          const form = new FormData();
          form.append("service_name_de", this.service.service_name_de);
          form.append("photo", this.service.image.file);

          const res = await servicesService.createService(form);

          const promises = this.service.text_points.map((point) => {
            const formPoint = new FormData();
            formPoint.append("service_id", res.id);
            formPoint.append("text", point.text);
            formPoint.append("name", point.text);
            return servicesService.createServicePoint(formPoint);
          });

          await Promise.all(promises);

          this.$emit("success", "Послугу додано");
          this.closeModal();
        } catch (e) {
          console.error(e);
        } finally {
          this.isLoadingBtn = false;
        }
      }
    },
    async updateService() {
      this.$v.service.$touch();
      if (!this.$v.service.$invalid) {
        this.isLoadingBtn = true;
        try {
          const form = new FormData();
          form.append("service_name_de", this.service.service_name_de);
          if (this.service.image.file) {
            form.append("photo", this.service.image.file);
          }

          const res = await servicesService.updateService(
            this.service.id,
            form
          );

          const promises = this.service.text_points.map((point) => {
            const formPoint = new FormData();
            if (point.is_new) {
              formPoint.append("service_id", res.id);
              formPoint.append("text", point.text);
              formPoint.append("name", point.text);
              return servicesService.createServicePoint(formPoint);
            } else if (point.is_edited) {
              formPoint.append("service_id", res.id);
              formPoint.append("uuid", point.uuid);
              formPoint.append("text", point.text);
              formPoint.append("name", point.text);
              formPoint.append("delete", point.delete || false);
              return servicesService.updateServicePoint(point.id, formPoint);
            }
          });

          await Promise.all(promises);

          this.$emit("success", "Послугу оновлено");
          this.closeModal();
        } catch (e) {
          console.error(e);
        } finally {
          this.isLoadingBtn = false;
        }
      }
    },
    closeModal() {
      this.$emit("close");
    },
    addPoint() {
      this.service.text_points.push({
        id: Date.now(),
        text: "",
        is_new: true,
        is_edited: false,
      });
    },
    async deleteTextPoint(point_id,index) {
      await servicesService.deleteServicePoint(point_id).then(() => {
        this.service.text_points.splice(index, 1);
      });
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    addFiles(newFile) {
      this.imageError = "";
      const file = newFile && newFile[0];
      console.log(file, newFile, "FILES");
      if (!file) return;

      if (!this.allowedTypes.includes(file.type)) {
        this.imageError =
          "Невірний формат файлу. Дозволені формати: PNG або JPG.";
        return false;
      }

      if (file.size > this.maxSize) {
        this.imageError = `Файл ${file.name} перевищує 1MB`;
        return false;
      }

      this.$set(this.service, "image", {
        id: Date.now(),
        path: URL.createObjectURL(file),
        name: file.name,
        file,
      });
      this.isDragging = false;
      this.imageError = "";
    },

    deleteImage() {
      this.service.image = null;
    },

    handleDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      const droppedFiles = event.dataTransfer.files;
      this.addFiles(droppedFiles);
    },

    handleFileSelect(event) {
      const selectedFiles = event.target.files;
      this.addFiles(selectedFiles);
    },
    textPointsDescriptionErrors(index) {
      const errors = [];
      if (
        this.$v.service.text_points.$each?.[index]?.text.$dirty &&
        !this.$v.service.text_points.$each?.[index]?.text.required
      ) {
        errors.push("");
      }
      return errors;
    },
  },
  computed: {
    imagesError() {
      const errors = [];
      if (this.$v.service.image.$dirty && !this.$v.service.image.required) {
        errors.push("");
      }
      return errors;
    },
    nameError() {
      const errors = [];
      if (
        this.$v.service.service_name_de.$dirty &&
        !this.$v.service.service_name_de.required
      ) {
        errors.push("");
      }
      return errors;
    },

    text_pointsError() {
      const errors = [];
      if (
        this.$v.service.text_points.$dirty &&
        !this.$v.service.text_points.required
      ) {
        errors.push("");
      }
      return errors;
    },
  },
};
</script>

<style scoped>
.drop-zone {
  width: 100%;
  height: 295px;
  border-radius: 4px;
  border: 1px dashed #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-top: 26px;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
</style>